import {  writable, get } from 'svelte/store';
import { CollectionORM, API } from './api.js';

export const authToken = writable(localStorage.getItem('auth_token'));

export const SubscriptionTypes = CollectionORM(API.service('subscription_types'), [], 'guid')

// change with orders to get shipments array to change view.
export const Orders = CollectionORM(API.service('shop/orders/needs_shipment/'), [], 'guid', {
  addTracking: function(data) {
    return API.service('shop/shipments/:guid/mark_order_as_fulfilled/').post(data);
  }
});

export const Curriers = CollectionORM(API.service('shop/delivery_methods'), [], 'guid');

export const CIViewer = writable(null);

export const SystemUser = CollectionORM(API.service('system_me', false), null, 'cuid', {
    login: async function(data) {
        return await API.service('api-token-auth').post(data);
    },
});

export const User = CollectionORM(API.service('me', false), null, 'cuid', {
    login: async function(data) {
        return await API.service('api-token-auth').post(data);
    },
    sendCode: async function(data) {
      let password = API.service('forgot_password');
      return password.post(data);
    },
    resetPassword: async function(data) {
      let password = API.service('reset_password');
      return password.post(data);
    },
});
